import { render } from "./ProductSorting.vue?vue&type=template&id=300ee86d"
import script from "./ProductSorting.vue?vue&type=script&lang=js"
export * from "./ProductSorting.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dominikheun/Coding/kraiburg-website-typo3/extensions/products/Resources/Private/Vue/product-list/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__